import { i18nMark } from 'lingui-react';

const messages = {
  campaigns: i18nMark('Campaigns'),
  engine: i18nMark('Engine'),
  make: i18nMark('Make'),
  model: i18nMark('Model'),
  odometer: i18nMark('Odometer'),
  pmStatus: i18nMark('Maintenance'),
  serial: i18nMark('Serial'),
  title: i18nMark('Asset'),
  unit: i18nMark('Unit'),
  warranty: i18nMark('Warranty'),
  vin: i18nMark('VIN'),
  year: i18nMark('Year'),
  pmStatusTooltipGreen: i18nMark('Current'),
  pmStatusTooltipYellow: i18nMark('Due'),
  pmStatusTooltipRed: i18nMark('Overdue'),
  warrantyTooltipGreen: i18nMark('Fully Covered'),
  warrantyTooltipYellow: i18nMark('Partially Covered'),
  warrantyTooltipRed: i18nMark('Expired'),
  warrantyTooltipGrey: i18nMark('No Coverage'),
  campaignsTooltipGreen: i18nMark('Current'),
  campaignsTooltipRed: i18nMark('Campaign Due'),
};


export default messages;



// WEBPACK FOOTER //
// ./compositions/AssetsWidget/messages.js